import { render, staticRenderFns } from "./swlegalperson.vue?vue&type=template&id=7b92537f&scoped=true&"
import script from "./swlegalperson.vue?vue&type=script&lang=js&"
export * from "./swlegalperson.vue?vue&type=script&lang=js&"
import style0 from "./swlegalperson.vue?vue&type=style&index=0&id=7b92537f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b92537f",
  null
  
)

export default component.exports